import React from "react";
import styled from "styled-components";
import { getHeaderTheme } from "../../../config/headerTheme";

const QuizList = ({ quizzes, onSelect, onReset, isHost, isStarting, resettingQuizId }) => {
  const clampProgress = (value) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return 0;
    return Math.max(0, Math.min(100, numeric));
  };

  return (
    <>
      <SectionTitle>{isHost ? "Trivias disponibles" : "Trivias activas"}</SectionTitle>
      <QuizGrid>
        {quizzes.map((quiz) => {
          const progressValue = clampProgress(quiz.progressPercentage);
          const isResetting = resettingQuizId === quiz.id;
          return (
            <QuizCard key={quiz.id}>
              <QuizHeader>
                <div>
                  <h4>{quiz.title}</h4>
                </div>
              </QuizHeader>
              {(quiz.difficulty || quiz.category) && (
                <QuizMeta>
                  {quiz.difficulty && <Badge $variant={quiz.difficulty}>{quiz.difficulty}</Badge>}
                  {quiz.category && <Badge $variant="category">{quiz.category}</Badge>}
                </QuizMeta>
              )}
              <QuizStats>
                {Number.isFinite(quiz.questionsCount) && (
                  <span>{quiz.questionsCount} preguntas</span>
                )}
                {Number.isFinite(quiz.totalDocuments) && (
                  <span>{quiz.totalDocuments} documentos</span>
                )}
                {quiz.duration && <span>{quiz.duration}</span>}
              </QuizStats>
              {isHost && (
                <TopicProgressWrap>
                  <TopicProgressHeader>
                    <small>Avance</small>
                    <strong>{progressValue.toFixed(1)}%</strong>
                  </TopicProgressHeader>
                  <TopicProgressTrack>
                    <TopicProgressFill $width={progressValue} />
                  </TopicProgressTrack>
                </TopicProgressWrap>
              )}
              <ActionRow>
                
                <PrimaryButton
                  type="button"
                  onClick={() => onSelect(quiz)}
                  disabled={isStarting}
                >
                  {isHost ? (isStarting ? "Cargando..." : "Jugar") : "Ver detalles"}
                </PrimaryButton>
              </ActionRow>
            </QuizCard>
          );
        })}
      </QuizGrid>
    </>
  );
};

export default QuizList;

const SectionTitle = styled.h3`
  font-size: 18px;
  margin: 0 0 12px;
  color: #111827;
`;

const QuizGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const QuizCard = styled.div`
  background: #ffffff;
  border-radius: 18px;
  padding: 18px;
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const QuizHeader = styled.div`
  text-align: center;

  h4 {
    margin: 0 0 6px;
    font-size: 20px;
    color: #0f172a;
  }

  p {
    margin: 0;
    color: #6b7280;
    font-size: 15px;
  }
`;

const QuizMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
`;

const Badge = styled.span`
  font-size: 13px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid;
  color: ${({ $variant }) => {
    if ($variant === "Facil") return "#15803d";
    if ($variant === "Medio") return "#92400e";
    if ($variant === "Dificil") return "#b91c1c";
    if ($variant === "category") return "#b91c1c";
    return "#1d4ed8";
  }};
  background: ${({ $variant }) => {
    if ($variant === "Facil") return "#dcfce7";
    if ($variant === "Medio") return "#fef3c7";
    if ($variant === "Dificil") return "#fee2e2";
    if ($variant === "category") return "#fee2e2";
    return "#dbeafe";
  }};
  border-color: ${({ $variant }) => {
    if ($variant === "Facil") return "#86efac";
    if ($variant === "Medio") return "#fcd34d";
    if ($variant === "Dificil") return "#fecaca";
    if ($variant === "category") return "#fecaca";
    return "#bfdbfe";
  }};
`;

const QuizStats = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 15px;
  color: #6b7280;
`;

const TopicProgressWrap = styled.div`
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
  display: grid;
  gap: 6px;
`;

const TopicProgressHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  small {
    color: #6b7280;
    font-size: 14px;
  }

  strong {
    color: #111827;
    font-size: 15px;
  }
`;

const TopicProgressTrack = styled.div`
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: #e5e7eb;
  overflow: hidden;
`;

const theme = getHeaderTheme();

const TopicProgressFill = styled.div`
  height: 100%;
  border-radius: 999px;
  background: ${theme.primary};
  transition: width 0.3s ease;
  width: ${({ $width }) => `${$width || 0}%`};
`;

const ActionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const SecondaryButton = styled.button`
  border: 1px solid #d1d5db;
  border-radius: 999px;
  padding: 12px 14px;
  background: #ffffff;
  color: #111827;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  white-space: nowrap;
`;

const PrimaryButton = styled.button`
  border: none;
  border-radius: 999px;
  padding: 12px 18px;
  background: ${theme.primary};
  color: ${theme.text};
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  flex: 1;
`;
